<template>
  <v-app>
    <SideAndAppBar v-if="!errflg" />
    <v-main>
      <router-view :key="route.path.indexOf('TopPage') !== -1 ? route.fullPath : ''" />
      <ConfirmBar />
      <LoadingBar />
    </v-main>
    <AppFooter v-if="!errflg" />
  </v-app>
</template>

<script lang="ts">
import AppFooter from '@/components/AppFooter.vue';
import ConfirmBar from '@/components/ConfirmBar.vue';
import LoadingBar from '@/components/LoadingBar.vue';
import SideAndAppBar from '@/components/SideAndAppBar.vue';
import { useRouter } from '@/router/use-router';
import { useAppStore } from '@/stores/app';
import { computed, defineComponent, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'App',
  components: {
    SideAndAppBar,
    AppFooter,
    ConfirmBar,
    LoadingBar,
  },
  setup() {
    const appStore = useAppStore();

    const router = useRouter();
    const route = useRoute();

    function updateTitle() {
      appStore.setPageTitle(document.title);
    }

    onMounted(() => {
      // 初期ロード時のタイトル設定
      updateTitle();
    });

    // ルートが変更された時のウォッチャー
    watch(
      () => router.currentRoute.value.path,
      () => {
        updateTitle();
      },
    );

    return { errflg: computed(() => appStore.errflg), route };
  },
});
</script>

<style lang="scss">
html body .v-application .v-application__wrap {
  min-height: 0 !important;
}

:root {
  --v-font-size: 14px !important;
  --v-max-width: 1800px !important;
  --background-color: #ffffff;
  --text-color: #000000;
  --color-blue: #0066cc;
  --color-red: #e20a17;
  --color-yellow: #fff905;
  --color-light-yellow: #ffeb3b;
  --color-light-blue: #f0f8ff;
  --color-light-green: #e8f5e9;
  --color-light-gray: #f5f5f5;
  --color-light-red: #ffcccc;
  --color-table-border: #000000;
}

body {
  font-family: Roboto, 'Noto Sans JP', sans-serif !important;
}
html {
  font-size: var(--v-font-size) !important;
}

div.v-input__details {
  display: none;
}

.v-label.v-field-label--floating {
  --v-field-label-scale: 1rem !important;
}

div.v-selection-control-group.v-selection-control-group--inline * {
  max-height: 2rem;
}

input,
span {
  font-size: 1rem !important;
}

main.v-main {
  padding-top: 30px;
  // padding-bottom: 40px;
  // height: 861px;

  background-color: var(--background-color);
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div.v-application {
    width: 100%;
    & > div.v-application__wrap {
      min-height: 0 !important;
      max-height: none !important;
      // height: 861px !important;
      // padding-bottom: 40px;
      // & > div.v-container {
      //     padding-bottom: 40px;
      // }
    }
  }
}

.v-container {
  max-width: var(--v-max-width);
}

div.area-operate-button div.v-container {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 0px;
}

button.v-btn {
  width: 10rem;

  &.btn-blue {
    background-color: var(--color-blue);
    color: white;
  }

  &.btn-yellow {
    background-color: var(--color-yellow);
  }

  &.btn-red {
    background-color: var(--color-red);
    color: white;
  }
}

.alert-text {
  font-weight: bold;
}

.error-box {
  color: var(--color-red);
}

.required-input > .v-input__control {
  & > label:first-of-type::after,
  & > .v-field > .v-field__field > label::after,
  & > label:first-of-type::after,
  div.required-input:not(.v-input):after {
    content: '🞸';
    color: var(--color-red);
  }
}

.required-input-2 > .v-input__control {
  & > label:first-of-type::after,
  & > .v-field > .v-field__field > label::after,
  & > label:first-of-type::after,
  div.required-input:not(.v-input):after {
    content: '🞸';
    color: var(--color-blue);
  }
}

.text {
  font-size: 1rem !important;
}

.my-pa-0 {
  padding: 0px;
}

.mdi-checkbox-marked {
  color: var(--color-blue);
}

.v-radio .v-icon {
  color: var(--color-blue);
}

div.v-select.compact {
  .v-field {
    padding-right: 0.1em !important;
  }
  .v-field__input {
    min-height: 0 !important;
    padding: 0 0.2em !important;
  }
  div.v-field__append-inner {
    font-size: 0.8em;
  }
}

.large-checkbox {
  label {
    font-size: 1.2em !important;
  }
  i {
    font-size: 1.5em !important;
  }
}
</style>
